import { AccountBalanceWallet, CurrencyRupee,  Sync } from '@mui/icons-material'
import { Box, DialogActions, Grid, TextField, Typography } from '@mui/material'
import { Button, Container } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import PriceTable from './PriceTable';
import { useEffect, useState } from 'react';
import DialogBox from '../CommanComponents/DialogBox';
import { toast } from 'react-toastify';
import GradientLoader from '../CommanComponents/GradientLoader';
import { callPostApi } from '../API/ApiCallFunction';
import InfoPopover from '../CommanComponents/InfoPopover';

export default function Wallet() {
        const navigate = useNavigate();
        const [open, setOpen] = useState(false);
        const user = JSON.parse(sessionStorage.getItem("user") || "{}"); 
        const [addAmount, setAddAmount]= useState('')
        const [addDesc, setAddDesc]= useState('')
        const [errors, setErrors] = useState({});
        const [loading, setLoading] = useState(false);
        const validate = () => {
          const newErrors = {};
          if (!addAmount || isNaN(addAmount) || Number(addAmount) <= 0) { newErrors.addAmount= 'Enter a valid Amount';}
          if (!addDesc) { newErrors.addDesc= 'Enter Description'; }
          setErrors(newErrors);
           return Object.keys(newErrors).length === 0;
          };
      
        const handleSave = () => {
          if (!validate()) return;  
            addAmountApi(); 
        }
      
        // Add Amont API
        const addAmountApi= async () => {
         try {
              setLoading(true);
              const storeid = user.store_info.store_id;
              const payload = { mod: "WALLET_RECHARGE_LINK", data_arr: { store_id: storeid, amount: addAmount, pay_desc :addDesc } };
              const apiResult = await callPostApi("store-wallet", payload);
              if (apiResult.status === "200") {
                setOpen(false);
                setAddAmount(' ')
                setAddDesc(' ')
                toast.success(apiResult.data.message);
                const payment_link = apiResult.data.payment_link;
                window.open(payment_link, '_blank');
              } else {
                     toast.info(apiResult.status_message);
              } 
             } catch (err) { 
            } finally {
                   setLoading(false);
                 }
            }; 

        //Refresh Amount API
       const refreshPage = async (e) => {
          setLoading(true);
          try {
            const storeid = user.store_info.store_id;
            const payload = { mod: "STORE_DETAIL", data_arr: { store_id: storeid,},};
            const apiResult = await callPostApi("store-login", payload);
            if (apiResult.status === "200" && apiResult.data) {
              const successData = apiResult.data; 
              const storeInfo = successData.store_info;
              if (storeInfo) {
                   sessionStorage.setItem("user", JSON.stringify(successData));
                   window.dispatchEvent(new Event('refreshNavbar'));
                   window.dispatchEvent(new Event('refreshPriceTable'));
                  }
                  setLoading(false);  
               } else {
                 if (apiResult.status === "401") {
                   setLoading(false);
                 } else {
                   setLoading(false);
                 }
               }
             } catch (error) {
                setLoading(false);
             }
           };

     useEffect(() => {
          refreshPage();
     }, []);
                  
  return (
    <Container>
       <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
         <Button variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }}
          onClick={() =>  {  if (window.history.length > 2) { navigate(-1); } else { navigate("/dashboard"); }} }> Back </Button>
      </Box>
      <Typography variant="h6"  gutterBottom sx={{ background: 'linear-gradient(195deg, #49a3f1, #1A73E8)',
        p: 1, color: '#ffffff',  borderRadius: '4px', mb: 3,}}> <AccountBalanceWallet/>  Wallet </Typography>
      
       <Box sx={{backgroundColor:'#f2f2f2', borderRadius:'8px',
        boxShadow: 'rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;'}}>
        <Typography sx={{px:2, py:1}} ><Sync onClick ={() => refreshPage()}/> </Typography>
         <Grid container spacing={2} sx={{backgroundColor:'#ffffff',  borderTopLeftRadius:'12px', borderTopRightRadius:'12px',
          borderBottomRightRadius:'8px',borderBottomLeftRadius:'8px', boxShadow: 'rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;', py:2 ,px:2}}>
         <Grid item size={{ xs: 12,sm:12, md: 4,  }}>
           <Typography sx={{mb:1, color:'#888'}}>Wallet Balance <InfoPopover triggerTabIndex={-1} title="Wallet Balance"  
               description="Available funds in your Cashi wallet that can be used for generating Coupons." />
           </Typography>
             <Box sx={{display:'flex', alignItems:'center'}}>
              <CurrencyRupee sx={{fontSize:'35px',color:'#0a32d4ff'}} /> 
              <Typography variant="h4" sx={{color:'#0a32d4ff'}}>{user.store_info.wallet_amount}</Typography>
              </Box> 
             <Box sx={{display:'flex', my:3}}>
              <Button variant="contained" sx={{background:'linear-gradient(195deg, #66BB6A, #43A047)'}}
               onClick={() => setOpen(true)}>Add Balance</Button>
              {/* <Button variant="contained" sx={{mx:1}}>Manage Billing</Button> */}
             </Box>
           </Grid>
         </Grid>
       </Box>  
       <Box sx={{my:2}}> <PriceTable /> </Box>   
       
      {/* Add balance */}
       <DialogBox open={open} onClose={() => setOpen(false)} title="Add Balance">
         <TextField className="transparent-textfield" fullWidth margin="normal" label="Enter Amount" required  value={addAmount}  
           onChange={(e) =>  { setAddAmount(e.target.value); setErrors(prev => ({ ...prev, addAmount: undefined }));}}
           error={!!errors.addAmount} helperText={errors.addAmount} type="number" inputProps={{ min: 1 }}/>

        <TextField className="transparent-textfield" fullWidth margin="normal" label="Remark for bank *" value={addDesc}  
           onChange={(e) =>  { setAddDesc(e.target.value); setErrors(prev => ({ ...prev, addDesc: undefined })); }}
           error={!!errors.addDesc} helperText={errors.addDesc} type="text" inputProps={{ min: 1 }}/>
        <DialogActions>
           <Button onClick={() => setOpen(false)} color="primary"> Cancel </Button>
           <Button  color="primary" variant="contained" onClick={() => handleSave()}> Ok </Button>
        </DialogActions>
      </DialogBox> 
                    
      {loading && <GradientLoader text="Loading" />}   {/* loader */ } 
    </Container>
  )
}
